import { loadingActions } from './slice'

export const { startLoading, stopLoading } = loadingActions

export default loadingActions
